import { render, staticRenderFns } from "./ScaleQuestion.vue?vue&type=template&id=7c870b36&scoped=true"
import script from "./ScaleQuestion.vue?vue&type=script&lang=js"
export * from "./ScaleQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c870b36",
  null
  
)

export default component.exports